<template>
  <div class="papers-page">
    <div v-loading="loading" element-loading-text="加载中..." class="content-wrapper">
      <div class="section-header">
        <h3>投稿记录</h3>
        <el-button type="primary" plain size="small" @click="$router.push('/paper')">
          <i class="el-icon-plus"></i> 新增投稿
        </el-button>
      </div>

      <div v-if="papers.length === 0" class="empty-state">
        <i class="el-icon-document-delete"></i>
        <p>暂无投稿记录</p>
        <el-button type="primary" @click="$router.push('/paper')">去投稿</el-button>
      </div>

      <div v-else class="papers-list">
        <div v-for="item in papers" :key="item.id" class="paper-item">
          <div class="item-header">
            <h4 class="item-title">{{ item.title }}</h4>
            <el-tag 
              :type="getReviewStatusType(item.review_status)" 
              size="small"
            >
              {{ getReviewStatusText(item.review_status) }}
            </el-tag>
          </div>
          
          <div class="item-info">
            <div class="info-row">
              <span class="info-label">作者：</span>
              <span class="info-value">{{ item.authors }}</span>
            </div>
            <!-- <div class="info-row">
              <span class="info-label">关键词：</span>
              <span class="info-value">{{ item.keywords }}</span>
            </div> -->
            <div class="info-row">
              <span class="info-label">提交时间：</span>
              <span class="info-value">{{ formatDate(item.createtime) }}</span>
            </div>
            <div class="info-row" v-if="item.review_time">
              <span class="info-label">审核时间：</span>
              <span class="info-value">{{ formatDate(item.review_time) }}</span>
            </div>
          </div>

          <div class="item-abstract" v-if="item.abstract">
            <span class="info-label">摘要：</span>
            <p>{{ item.abstract }}</p>
          </div>

          <div v-if="item.review_status === 2 && item.review_comment" class="review-comment">
            <el-alert
              :title="'审核意见：' + item.review_comment"
              type="error"
              :closable="false"
              show-icon
            ></el-alert>
          </div>

          <!-- <div class="item-actions">
            <el-button type="primary" size="small" plain icon="el-icon-view">
              查看摘要
            </el-button>
            <el-button 
              v-if="item.review_status === 2" 
              type="warning" 
              size="small"
              plain
            >
              重新投稿
            </el-button>
          </div> -->
        </div>
      </div>
      
      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="pagination.total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pagination.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          background
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { paperApi } from '@/api'
import { formatDate, getReviewStatusText, getReviewStatusType } from '@/utils'

export default {
  name: 'UserPapers',
  data() {
    return {
      papers: [],
      loading: false,
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  
  mounted() {
    this.fetchPapers();
  },
  methods: {
    formatDate,
    getReviewStatusText,
    getReviewStatusType,
    async fetchPapers() {
      this.loading = true;
      try {
        const params = {
          page: this.pagination.page,
          limit: this.pagination.limit
        };
        const res = await paperApi.getMyPapers(params);
        if (res && res.code === 1 && res.data) {
          this.papers = Array.isArray(res.data.list) ? res.data.list : [];
          this.pagination.total = res.data.total || 0;
        } else {
          this.papers = [];
          this.pagination.total = 0;
          console.error('获取投稿记录失败:', res ? res.msg : '未知错误');
        }
      } catch (error) {
        console.error('获取投稿记录失败:', error);
        this.papers = [];
        this.pagination.total = 0;
        this.$message.error(error.message || '获取投稿记录失败');
      } finally {
        this.loading = false;
      }
    },
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; // 重置为第一页
      this.fetchPapers();
    },
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchPapers();
    }
  }
}
</script>

<style lang="scss" scoped>
.papers-page {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;

  h3 {
    font-size: 20px;
    color: #1a237e;
    margin: 0;
  }
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  color: #999;

  i {
    font-size: 64px;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
    margin-bottom: 24px;
  }
}

.papers-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.paper-item {
  background: #f8f9fc;
  border-radius: 12px;
  padding: 24px;
  transition: all 0.3s;

  &:hover {
    background: #f0f2f8;
  }
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;

  .item-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a237e;
    margin: 0;
    flex: 1;
    margin-right: 16px;
  }
}

.item-info {
  margin-bottom: 16px;
}

.info-row {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;

  .info-label {
    color: #999;
    min-width: 80px;
    flex-shrink: 0;
  }

  .info-value {
    color: #333;
  }
}

.item-abstract {
  margin-bottom: 16px;
  font-size: 14px;

  .info-label {
    color: #999;
  }

  p {
    color: #666;
    line-height: 1.8;
    margin: 8px 0 0;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.review-comment {
  margin-bottom: 16px;
}

.item-actions {
  display: flex;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px dashed #e0e0e0;
}

.pagination-wrapper {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>
